import config from '@config';
import {
  initializeHttp,
  setupRequestInterceptor,
} from '@gasbi/shared/common/utils/http';

const instance = initializeHttp(config.VITE_API_URL, [setupRequestInterceptor]);

export default instance;
